module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"copyLink":"Копировать ссылку","copied":"Ссылка скопирована"}}')
  delete Component.options._Ctor
}
